<template>
  <div class="row" id="financialReports">
    <div class="col-md-8 col-sm-12 offset-md-2">
      <div class="m-portlet">
        <div class="m-portlet__head mt-3">
          <div class="m-portlet__head-caption f-center" style="justify-content: space-between; height: 100%">
            <div class="m-portlet__head-title" style="width: 100%;">

              <div class="row" style="width: 100%; height: 100%;">
                <div class="col-sm-12 col-md-auto md-align">
                  <h3 class="m-portlet__head-text">Financial Report: <span style="font-weight: normal;" class="ml-2">{{ startDate }} - {{ endDate }}</span></h3>
                </div>
                <div class="col md-align">
                  <div class="row">
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <history-lock-button :startDate="startDate" :endDate="endDate"></history-lock-button>
                    </div>
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <a :href="invoicesInRangeUrl" target="_blank" class="btn btn-default btn-sm mr-2">
                        Download PDFs
                      </a>
                    </div>
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <button class="btn btn-dark btn-sm mr-2" @click="openPdfModal">
                        Export PDF
                      </button>
                    </div>
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <button class="btn btn-dark btn-sm mr-2" @click="exportXLS">
                        Export XLS
                      </button>
                    </div>
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <button class="btn btn-danger btn-sm mr-2" @click="resetPdf">
                        Reset PDF
                      </button>
                    </div>
                    <div class="text-sm-center col-sm-12 col-md-auto p-1">
                      <div class="btn btn-metal btn-sm" @click="shiftByMonth(-1)" title="Previous month"><<</div>
                      <date-range-picker ref="datepicker"
                                         opens="left"
                                         :startDate="startDate"
                                         :endDate="endDate"
                                         @update="onDateRangeSelected"
                                         class="financialReportPicker"
                      ></date-range-picker>
                      <div class="btn btn-metal btn-sm" @click="onCalendarClick">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div class="btn btn-metal btn-sm" @click="shiftByMonth(1)" title="Next month">>></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="m-portlet__body" v-if="!reports">
          <div class="row">
            <div class="col-12">
              <loader class="loader-center"></loader>
            </div>
          </div>
        </div>
      </div>

      <div v-if="reports">
        <div class="m-portlet">
          <div class="m-portlet__head mt-3">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  Total:
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-12">
                <table class="table table-stripped table-responsive">
                  <tr>
                    <th>Client</th>
                    <th>
                      <input type="checkbox" v-model="global_invoice_checkbox">
                    </th>
                    <th>PDF</th>
                    <th>Predicted income</th>
                    <th>Current income</th>
                    <th></th>
                    <th>
                      <global-send-button
                        :bus="invoiceBus"
                        :reports="reports"
                        @uncheck="global_invoice_checkbox = false"
                      ></global-send-button>
                    </th>
                  </tr>
                  <tr v-for="report in reports" :class="{'total-style' : report.client.name === 'TOTAL'}">
                    <td>
                      <span class="m-badge m-badge--primary m-badge--dot" v-if="report.client.name !== 'TOTAL'"></span>
                      <span class="" v-else></span>
                      <a style="font-weight: bolder; font-size: 1.25rem;" :href="'#' + report.client.name.replace(' ', '_')">{{ report.client.name }}</a>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <span v-if="report.client.name !== 'TOTAL' && report.generated_money > 0">
                        <input type="checkbox" v-model="report.client.invoice_checkbox">
                      </span>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <div class="float-left" v-for="invoice in report.client.invoices" v-if="invoice.client_id === report.client.id && report.client.name !== 'TOTAL'">
                        <a :href="invoice.preview_url" target="_blank">PDF</a>
                      </div>
                      <div class="clearfix"></div>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <span>{{ report.predicted_income || '-' }}</span>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <div class="float-left" v-if="report.generated_money > 0">
                        <b style="font-size: 1.25rem; color: #575962;">
                          € {{ report.generated_money }}
                        </b>
                      </div>
                      <div class="clearfix"></div>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <client-invoice-button
                        v-if="report.client.name !== 'TOTAL' && report.generated_money > 0"
                        :startDate="startDate"
                        :endDate="endDate"
                        :client="report.client"
                        :projects="report.projects"
                        @invoiced="fetchData()"
                      ></client-invoice-button>
                    </td>
                    <td style="white-space:nowrap; width:1%;">
                      <div v-if="report.client.name !== 'TOTAL' && report.client.invoices.length > 0" style="display: inline;">
                        <invoice-send-button
                          :startDate="startDate"
                          :endDate="endDate"
                          :client="report.client"
                          :bus="invoiceBus"
                          @poolInvoiceData="poolInvoiceData()"
                        ></invoice-send-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="m-portlet" v-for="report in reports" :id="report.client.name.replace(' ', '_')" v-if="report.client.name !== 'TOTAL'">
          <div class="m-portlet__head mt-3">
            <div class="m-portlet__head-caption f-center" style="justify-content: space-between; height: 100%">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  {{ report.client.name }}
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-12">
                <div class="row client light-hover ml-1" v-for="projectReport in report.projects">
                  <div class="col">
                    <i class="mr-2">{{ projectReport.project.name }}</i>
                  </div>
                  <div class="col-auto">
                    <span v-if="projectReport.income_types.hourly_total > 0">
                      [ {{ report.client.price_per_hour }} € X {{ projectReport.income_types.hourly_total }}h ]
                    </span>

                    <span :class="{
                      'worth' : isWorthIt(projectReport.engineering_hours_total, report.client.price_per_hour, projectReport.income_types.fixed_price_total),
                      'not-worth' : !isWorthIt(projectReport.engineering_hours_total, report.client.price_per_hour, projectReport.income_types.fixed_price_total)
                    }">

                      <span v-if="projectReport.income_types.fixed_price_total > 0 && projectReport.engineering_hours_total > 0">
                        [ {{ $root.secondsToTimestring(projectReport.engineering_hours_total) }} X {{ report.client.price_per_hour }} € ]
                        {{ isWorthIt(projectReport.engineering_hours_total, report.client.price_per_hour, projectReport.income_types.fixed_price_total) ? '<' : '>' }}
                        [ {{ projectReport.income_types.fixed_price_total }} € ]
                      </span>

                    </span>
                    <span v-if="projectReport.income_types.fixed_price_total > 0 && projectReport.engineering_hours_total == 0">
                      [ {{ projectReport.income_types.fixed_price_total }} € ]
                    </span>


                    <span v-if="projectReport.income_types.pvsyst_2d > 0">
                      [ {{ projectReport.income_types.pvsyst_2d }} x 2D Pvsyst ]
                    </span>
                    <span v-if="projectReport.income_types.pvsyst_3d > 0">
                      [ {{ projectReport.income_types.pvsyst_3d }} x 3D Pvsyst ]
                    </span>
                  </div>
                  <div class="col-auto" style="text-align: right">
                    <div class="row">
                      <div class="col-auto" v-if="projectReport.generated_money > 0">
                        {{ projectReport.generated_money }} €
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="pdfModal" :hideFooter="true" size="md" title="Generate invoice">

      <div class="form-group">

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">DTR</span>
          </div>
          <input type="number" class="form-control text-center" v-model="invoiceNumber" :disabled="generatingInvoice" placeholder="Next invoice number">
        </div>
      </div>
      <div class="form-group">
        <date-picker
          class="text-center"
          @dateSelected="invoiceDate = $event"
          :dateFormat="'dd M yyyy'"
          :defaultDate="invoiceDate"
          @blur="$v.invoiceDate.$touch()"></date-picker>
      </div>

      <div class="form-group">
        <label>GBP</label>
        <input type="number" class="form-control" v-model="exchangeRates[2]">
      </div>
      <div class="form-group">
        <label>USD</label>
        <input type="number" class="form-control" v-model="exchangeRates[3]">
      </div>
      <div class="form-group">
        <label>AUD</label>
        <input type="number" class="form-control" v-model="exchangeRates[4]">
      </div>

      <div class="mb-3">
        <span class="btn btn-sm btn-info" @click="showClients = !showClients">{{ showClients ? 'Hide' : 'Show' }} clients</span>
      </div>

      <div class="clients" v-show="showClients">

        <div class="client" v-for="report in reports" v-if="report.generated_money > 0 && report.client.name != 'TOTAL'">
          <span class="client-name" @click="expandClientProjects(report.client.id)">{{ report.client.name }}</span>
          <div class="projects pl-3" v-if="showClientProjects === report.client.id">
            <div v-if="report.client.projects.length === 0">No projects</div>
            <project-groups :projects="report.projects"></project-groups>
          </div>
        </div>

      </div>

      <div class="form-group" style="text-align:center;">
        <button class="btn btn-success" @click="exportPdf" v-if="!generatingInvoice" :disabled="!invoiceNumber">Generate</button>
        <button class="btn btn-success" v-if="generatingInvoice" :disabled="true">
          <i class="fa fa-sync fa-spin"></i>
        </button>
      </div>

    </b-modal>

  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
  import bModal from 'bootstrap-vue/src/components/modal'
  import DatePicker from '../../components/partials/Datepicker.vue'
  import ClientInvoiceButton from './ClientInvoiceButton.vue'
  import ProjectGroups from './ProjectGroups.vue'
  import InvoiceSendButton from './InvoiceSendButton.vue'
  import GlobalSendButton from './GlobalSendButton.vue'

  let invoicePool = null

  export default {
    components: {
      ClientInvoiceButton,
      DateRangePicker,
      'b-modal': bModal,
      'date-picker': DatePicker,
      ProjectGroups,
      InvoiceSendButton,
      GlobalSendButton,
    },

    data() {
      return {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
//        startDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
//        endDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        mothsCounter: 0,
        reports: null,
        currencies: null,
        invoiceNumber: null,
        generatingInvoice: false,
        invoiceDate: null,
        showClients: false,
        showClientProjects: null,
        exchangeRates: {
          //Same as in db table currencies
          2: null, //GBP
          3: null, //USD
          4: null, //AUD
        },
        global_invoice_checkbox: false,
        invoiceBus: new Vue(),

      }
    },
    created() {
      this.axios.get('currencies').then(response => {
        this.currencies = response.data
        this.fetchData()
      })
    },
    watch: {
      global_invoice_checkbox: function (value) {
        this.checkInvoiceCheckboxes(value)
      }
    },
    computed: {
      invoicesInRangeUrl() {
        return process.env.BASE_URL + '/invoice-zip?startDate=' + this.startDate + '&endDate=' + this.endDate
      }
    },
    methods: {
      expandClientProjects(client_id) {
        if (this.showClientProjects === client_id) {
          this.showClientProjects = null
        } else {
          this.showClientProjects = client_id
        }
      },
      onDateRangeSelected(event) {
        this.startDate = moment(event.startDate).format('YYYY-MM-DD')
        this.endDate = moment(event.endDate).format('YYYY-MM-DD')
        this.fetchData()
      },
      onCalendarClick() {
        document.querySelector('.reportrange-text').click()
      },
      fetchData() {
        this.invoices = null
        this.reports = null
        this.axios.get('reports/financial/clientsReport', {params: {startDate: this.startDate, endDate: this.endDate}})
          .then(response => {
            this.reports = response.data
            this.checkInvoiceCheckboxes(false)
          })
          .catch(error => {
            console.log(error)
          })
      },
      shiftByMonth(direction) {
        this.mothsCounter += direction
        this.startDate = moment().add(this.mothsCounter, 'month').startOf('month').format('YYYY-MM-DD')
        this.endDate = moment().add(this.mothsCounter, 'month').endOf('month').format('YYYY-MM-DD')
        this.fetchData()

      },
      openPdfModal() {
        this.invoiceDate = moment(this.endDate).format('DD MMM YYYY')
        this.$refs.pdfModal.show();
      },
      exportPdf() {
        this.generatingInvoice = true;

        this.axios.post('clients/invoice', {
          startDate: this.startDate,
          endDate: this.endDate,
          invoiceNumber: this.invoiceNumber,
          invoiceDate: this.invoiceDate,
          exchangeRates: this.exchangeRates,
        }).then(response => {
          this.generatingInvoice = false;
          let url = process.env.BASE_URL + '/invoice?name=' + response.data
//          let win = window.open(url, '_blank');

          this.invoiceNumber = null
          this.$refs.pdfModal.hide();
          this.fetchData()

        }).catch(err => {
          this.$awn.alert('Something wen\'t wrong');
          this.invoiceNumber = null
          this.$refs.pdfModal.hide();
        })
      },
      exportXLS() {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate,
          filename: moment().format('YYYY_MM_DD_HH_MM_SS') + '_financial.xls',
        }

        this.axios.get('reports/financial/export', {params: data, responseType: 'blob'})
          .then(res => {
            // makes user to download file
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', data.filename);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
          })
      },
      isWorthIt(seconds, hourly, moneyEarned) {
        let moneySpent = (seconds / 60 / 60) * hourly
        return moneyEarned > moneySpent
      },
      resetPdf() {
        if (!confirm("Are you sure?")) {
          return
        }

        if (this.$store.state.history.locked) {
          alert('History is locked, can\'t reset.')
          return;
        }

        this.axios.post('reports/financial/reset-pdfs', {
          startDate: this.startDate,
          endDate: this.endDate,
        }).finally(() => {
          this.fetchData()
        })

      },
      checkInvoiceCheckboxes(value) {
        _.each(this.reports, report => {
          if (report.client.name !== 'TOTAL' && report.generated_money > 0) {
            if (!report.client.invoice_checkbox) {
              this.$set(report.client, 'invoice_checkbox', value)
            } else {
              report.client.invoice_checkbox = value
            }
          }
        })
      },
      poolInvoiceData() {
        if (invoicePool) {
          return
        }
        invoicePool = setInterval(() => {
          this.axios.get('reports/financial/clientsReport', {params: {startDate: this.startDate, endDate: this.endDate}})
            .then(response => {
              let noMoreSending = true
              let reports = response.data

              _.each(reports, loadedReport => {

                _.each(this.reports, liveReport => {

                  if (loadedReport.client && liveReport.client && loadedReport.client.id === liveReport.client.id) {
                    liveReport.client.invoices = loadedReport.client.invoices

                    // this checks if any one invoice has is_sending status
                    // if so then we continue pooling
                    // if none are sending, we can cancel the interval
                    _.each(liveReport.client.invoices, i => {
                      if (i.is_sending) {
                        noMoreSending = false
                      }
                    })

                  }

                })

              })

              if (noMoreSending) {
                clearInterval(invoicePool)
              }

            })
        }, 4000)

      }
    }
  }
</script>

<style lang="scss">
#financialReports {
  .client-name {
    color: #5867dd;
    cursor: pointer;

    &:hover {
      /*text-decoration: underline;*/
    }
  }

  .header-button-row {
    .col {
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

  @media (min-width: 576px) {
    .md-align {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .financialReportPicker .reportrange-text {
    display: none !important;
  }

  .roboto {
    font-family: Roboto, serif;
  }

  .pointer {
    cursor: pointer;
  }

  .light-hover:hover {
    background: #fafafa;
  }

  .client {
    padding: 10px 0 10px 0;
  }

  .border-top {
    width: calc(100% - 20px);
    margin: 0 0 10px 10px;
    border-top: 1px solid black;
  }

  .total-style {
    border-top: 1px solid black;
    color: black !important;
    margin-top: 10px;

    &:hover {
      text-decoration: none !important;
    }
  }

  .not-worth {
    color: #931226;
  }

  .worth {
    color: #0e9946;
  }

  .table-stripped tr td {
    border-bottom: 1px solid #d2d4d9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financialReports/Index.vue